import axios from "axios"

import { userSessionStore } from "~/domain/user-session"
import { api } from "~/shared/api"

export function registerApiInterceptors() {
	api.interceptors.request.use(async (config) => {

		const isAuthApi = config.url && (
			config.url.includes("refresh-token")
			|| config.url.includes("clean-tokens")
			|| config.url.includes("auth")
		)

		if (!isAuthApi) {
			userSessionStore.updateActivityDate()
			await userSessionStore.waitForRefreshToken()
		}

		return config
	})

	api.interceptors.response.use(null, async (error) => {

		const isAuthApi = error.config.url && (
			error.config.url.includes("refresh-token")
			|| error.config.url.includes("clean-tokens")
			|| error.config.url.includes("auth")
		)

		if (axios.isAxiosError(error) && error.config) {
			if (error.response?.status === 401 && !isAuthApi) {

				if(!(await userSessionStore.refreshToken())) {
					await userSessionStore.logout()
				}

				return api.request(error.config)
			}
		}

		throw error
	})
}